import { FC, MouseEvent } from 'react';
import {
  IconButton,
  StarIcon
} from 'stubben-edge-unified-frontend-react-components';

export interface FavouriteToggleProps {
  isFavourited: boolean;
  onToggle: () => void;
  testIdentifier: string;
  /** When true, only show on parent group-hover */
  hoverReveal?: boolean;
  className?: string;
  size?: number;
}

const FavouriteToggle: FC<FavouriteToggleProps> = ({
  isFavourited,
  onToggle,
  testIdentifier,
  hoverReveal = false,
  className = '',
  size = 18
}) => {
  const handleClick = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    onToggle();
  };

  return (
    <IconButton
      type="button"
      mode="ghost"
      variant="ghost"
      className={`${hoverReveal ? 'opacity-0 group-hover:opacity-100 focus-visible:opacity-100' : ''} ${
        isFavourited ? 'opacity-100' : ''
      } ${className}`.trim()}
      onClick={handleClick}
      testIdentifier={testIdentifier}
      aria-label={isFavourited ? 'Remove from favourites' : 'Add to favourites'}
      aria-pressed={isFavourited}
      icon={
        <StarIcon
          size={size}
          color={isFavourited ? '#106df6' : '#667085'}
          fill={isFavourited ? '#106df6' : 'none'}
        />
      }
    />
  );
};

export default FavouriteToggle;
